<template>

  <div>

    <div id="intro" class="bg-image">
      <div class="container">
        <div class="row">
          <div class="col-sm-8 col-md-7 col-lg-6 pt-5">
            <br class="d-none d-lg-block">
            <br>
            <h1>Flexible Short-term <br class="d-none d-lg-block">Trailer Rental</h1>
            <p class="lead py-1 mb-4">Take the hassle out of owning by <br class="d-none d-lg-block">renting your next trailer with <strong>PNO</strong>.</p>
            <router-link to="/trailers" class="btn btn-lg btn-success px-4">Search trailers <i class="fa fa-chevron-right ml-1"></i></router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="container py-5 text-center">
      <div class="row">
        <div class="col-lg-12 col-xl-10 offset-xl-1">
          <h2>Focus on your core business</h2>
          <p class="lead grey pt-2">Rent a trailer with <strong>PNO</strong> for your next transportation need.</p>
          <hr>
          <p class="grey text-uppercase mt-4 mb-4"><small>You're in good company:</small></p>
          <smart-img preset="customer" :src="require('@/assets/img/logos/logo_postnord.png')" height="20" class="img-bw mb-3 mx-3" alt="Postnord logo" />
          <smart-img preset="customer" :src="require('@/assets/img/logos/logo_dhl.png')" height="20" class="img-bw mb-3 mx-3" alt="DHL logo" />
          <smart-img preset="customer" :src="require('@/assets/img/logos/logo_kn.png')" height="20" class="img-bw mb-3 mx-3" alt="Kuehne+Nagel logo" />
          <smart-img preset="customer" :src="require('@/assets/img/logos/logo_dsv.png')" height="20" class="img-bw mb-3 mx-3" alt="DSV logo" />
          <smart-img preset="customer" :src="require('@/assets/img/logos/logo_freja.png')" height="20" class="img-bw mb-3 mx-3" alt="FREJA logo" />
          <smart-img preset="customer" :src="require('@/assets/img/logos/logo_schenker.png')" height="20" class="img-bw mb-3 mx-3" alt="DB Schenker logo" />
        </div>
      </div>
    </div>

  	<pno-how />

  	<pno-prompt />
  
  </div>

</template>

<script>
import PnoHow from '@/components/PnoHow.vue'
import PnoPrompt from '@/components/PnoPrompt.vue'

export default {
  mounted() {
        this.$store.commit('meta/image', this.generateSmartImgUrl(require('@/assets/img/bg_pno_intro.jpg') , 'ogimage'));
    },
	components: { PnoHow, PnoPrompt },
}
</script>
